import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const ShopRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.shopList,
    children: [
      { index: true, lazy: () => import('./shop-list') },
      { path: ':id', lazy: () => import('./shop-detail') },
      {
        path: 'weddings',
        children: [{ path: ':id', lazy: () => import('./shop-detail') }],
      },
    ],
  },
  {
    path: ROUTES_PATH.shopApprovalRequestsList,
    children: [
      { index: true, lazy: () => import('./shop-approval-requests-list') },
      { path: ':id', lazy: () => import('./shop-approval-requests-detail') },
    ],
  },
];
